import React, { useState } from 'react';
import { API, BASE_URL } from '../../constant';
import Loading from "../Hooks/Loading";
import logo2 from "../../Media/LogoReverseWithTag.svg";
import { Link } from 'react-router-dom';

const ForgotPassword = () => {

const [email, setEmail] = useState('');
const [sentEmail, setSentEmail] = useState('');
const [error, setError] = useState("");
const [loading, setLoading] = useState(false);

const handleForgetPassword = async (e) => {
    e.preventDefault();
    try {
        setLoading(true);
        const response = await fetch(`${API}/email/forget-password`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
        });

        const data = await response.json();
        console.log(data);
        if (data?.error) {
            throw data?.error;
          } else {
            setSentEmail(data);
            console.log('Email sent successfully:', data);
          }
          setLoading(false);
    } catch (error) {
        console.error('Error sending email:', error);
        setError(error?.message ?? "Something went wrong!");
        setLoading(false);
    }
};
const content = ()=>{
    if(sentEmail){
        return <div className="success fade-in-down delay-1 notice">An email with password reset link has been sent. Please check your email.</div>
    }else if(sentEmail.error){
        return <div className="error fade-in-down delay-1 notice">Somthing went wrong, please try again after some time.</div>
    }else{
        return <form onSubmit={handleForgetPassword}>
                <label className="email input-field fade-in-down delay-3">
                    <input className="" type="email" value={email} name='forgetPasswordEmail' placeholder="Enter your email" onChange={(e) => setEmail(e.target.value)} required/>
                </label>
                <button className="btn btn-gradient btn-full btn-white  fade-in-down delay-4" type="submit">Submit</button>
            </form>
            
    }
}
return(
    <div className="forget-reset-password">
        {loading && <Loading />}

        <div className="container ">
            <div className="content-wrap bg-blue">
                <div className="quick-cope">
                    <div className="theme-form mt---30">
                        <img src={logo2} alt="logo-img" className='mb---30 fade-in-down delay-1'/>
                        <h2 className="mt---30 fade-in-down delay-2">Forget Password?</h2>
                        {content()}
                        <div className="btn btn-link btn-white mt---20 fade-in-down delay-5">
                            <Link to="/login">Back to Login</Link>
                        </div>
                    </div>
                    {error?<div className="error notice fade-in-down delay-1">{error}</div>:""}
                </div>
            </div>
        </div>
    </div>
);
};

export default ForgotPassword;